export default {
	path: '/api-call-err-log',
	redirect: '/api-call-err-log',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'ApiCallErrLog',
			component: () => import('@/views/mng/ApiCallErrLog'),
		},
	],
};
